import React, { useState } from "react";
import {
  Box,
  Heading,
  Text,
  HStack,
  Input,
  Button,
  useToast,
  useColorMode,
} from "@chakra-ui/react";
import axiosInstance from "../../helpers/axiosInstance";
import { useTranslation } from "..//LanguageTranslation/TranslationContext";
import Translate from "..//LanguageTranslation/Translate";

const JoinCommunitySection = () => {
  const { colorMode } = useColorMode();
  const toast = useToast();
  const { useTranslate } = useTranslation();

  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const placeholderText = useTranslate("Enter email");

  const handleSubscribe = async () => {
    if (!email) {
      toast({
        title: "Email is required.",
        status: "warning",
        duration: 3000,
        isClosable: true,
      });
      return;
    }

    setIsLoading(true);
    try {
      const res = await axiosInstance.post("/newsletter/", { 
        email, 
        is_manual: true,
        date: new Date().toISOString()
      });
      if (res.status === 201) {
        setEmail("");
        toast({
          title: "Subscribed successfully!",
          status: "success",
          duration: 3000,
          isClosable: true,
        });
      }
    } catch (err) {
      toast({
        title: "Subscription failed.",
        description: err?.response?.data?.message ?? err.message,
        status: "error",
        duration: 4000,
        isClosable: true,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Box
      display={{ base: "block", md: "none" }}
      // mt={12}
      p={6}
      bg={colorMode === "light" ? "#F7F7F7" : "gray.700"}
      borderRadius="lg"
      textAlign="center"
    >
      <Heading as="h2" size="lg" mb={4}>
        <Translate text="Join the Green & Wild Community!" />
      </Heading>

      <Text mb={6} w={{ base: "100%", md: "50%" }} mx="auto" textAlign="center">
        <Translate
          text="Subscribe to NOMAD360' newsletter for personalized travel tips,
          epic outdoor experiences, and exclusive offers. Connect with fellow
          explorers and start planning your next adventure today!"
        />
      </Text>

      <HStack
        maxW="500px"
        mx="auto"
        p={2}
        borderRadius="md"
        bg="white"
        boxShadow="sm"
        spacing={4}
      >
        <Input
          type="email"
          placeholder={placeholderText}
          variant="unstyled"
          px={4}
          flex="1"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <Button
          bg="black"
          color="white"
          transition="transform 0.3s"
          _hover={{
            transform: "scale(1.1)",
            // border: "2px solid #FFC719",
            // borderColor: "#FFC719",
            bg:"black"
          }}
          isLoading={isLoading}
          onClick={handleSubscribe}
        >
          <Translate text="Subscribe" />
        </Button>
      </HStack>
    </Box>
  );
};

export default JoinCommunitySection;
